export const formatCapitalizeInitials = (inputString: string) =>
  inputString.charAt(0).toUpperCase() +
  inputString.slice(1).replace(/_|\\-/, " ");

export const isValidString = (value: any) =>
  value != null && typeof value === "string" && value.trim().length > 0;

export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return false;
  }
  if (email.split("@").length !== 2 || email.includes("..")) {
    return false;
  }
  return true;
};
